export default () => ({
  dashboard: {},
  overview: [],
  pagination: {
    currentPage: 1,
    pageSize: 20,
    pageCount: 5,
    totalItems: 0,
  },
  filters: {
    keyword: "",
    advanced: {
      name: null,
      branch: null,
      responsible: null,
      talentPlatformProfile: null,
      pipeline: [],
      date: [],
      companySector: null,
    },
  },
});
